(() => {
  const verifiedRenditions = {"53234194448701":[{"url":"https://cdn.shopify.com/videos/c/vp/4346a49555194932b940937807f9bf43/4346a49555194932b940937807f9bf43.SD-480p-1.5Mbps-93832338.mp4","width":850,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/4346a49555194932b940937807f9bf43/4346a49555194932b940937807f9bf43.HD-1080p-7.2Mbps-93832338.mp4","width":1916,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/4346a49555194932b940937807f9bf43/4346a49555194932b940937807f9bf43.HD-720p-4.5Mbps-93832338.mp4","width":1276,"format":"mp4"}],"53234193498429":[{"url":"https://cdn.shopify.com/videos/c/vp/1658b0289bd347aba4bdc54aae70c4e5/1658b0289bd347aba4bdc54aae70c4e5.SD-480p-1.5Mbps-93832339.mp4","width":300,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/1658b0289bd347aba4bdc54aae70c4e5/1658b0289bd347aba4bdc54aae70c4e5.HD-1080p-7.2Mbps-93832339.mp4","width":674,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/1658b0289bd347aba4bdc54aae70c4e5/1658b0289bd347aba4bdc54aae70c4e5.HD-720p-4.5Mbps-93832339.mp4","width":450,"format":"mp4"}]};
  Object.assign(verifiedRenditions, {
    '53251821142333': [
      { url: 'https://cdn.shopify.com/videos/c/vp/d9ac8541f5e54182a155ead90bb652db/d9ac8541f5e54182a155ead90bb652db.SD-480p-1.5Mbps-93937511.mp4', width: 852, format: 'mp4' },
      { url: 'https://cdn.shopify.com/videos/c/vp/d9ac8541f5e54182a155ead90bb652db/d9ac8541f5e54182a155ead90bb652db.HD-720p-4.5Mbps-93937511.mp4', width: 1278, format: 'mp4' },
      { url: 'https://cdn.shopify.com/videos/c/vp/d9ac8541f5e54182a155ead90bb652db/d9ac8541f5e54182a155ead90bb652db.HD-1080p-7.2Mbps-93937511.mp4', width: 1918, format: 'mp4' }
    ],
    '53251819733309': [
      { url: 'https://cdn.shopify.com/videos/c/vp/d909cf60d61b483f9655b6b7ac09d1aa/d909cf60d61b483f9655b6b7ac09d1aa.SD-480p-1.5Mbps-93937512.mp4', width: 270, format: 'mp4' },
      { url: 'https://cdn.shopify.com/videos/c/vp/d909cf60d61b483f9655b6b7ac09d1aa/d909cf60d61b483f9655b6b7ac09d1aa.HD-720p-4.5Mbps-93937512.mp4', width: 404, format: 'mp4' },
      { url: 'https://cdn.shopify.com/videos/c/vp/d909cf60d61b483f9655b6b7ac09d1aa/d909cf60d61b483f9655b6b7ac09d1aa.HD-1080p-7.2Mbps-93937512.mp4', width: 608, format: 'mp4' }
    ]
  });
  Object.assign(verifiedRenditions, {"53255695171901":[{"url":"https://cdn.shopify.com/videos/c/vp/f389399980874237a036c727268b5ce3/f389399980874237a036c727268b5ce3.SD-480p-1.5Mbps-93963290.mp4","width":852,"height":480,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/f389399980874237a036c727268b5ce3/f389399980874237a036c727268b5ce3.HD-1080p-7.2Mbps-93963290.mp4","width":1920,"height":1080,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/f389399980874237a036c727268b5ce3/f389399980874237a036c727268b5ce3.HD-720p-4.5Mbps-93963290.mp4","width":1280,"height":720,"format":"mp4"}],"53255697891645":[{"url":"https://cdn.shopify.com/videos/c/vp/564e3beed1ab4c299257e117aacadcf5/564e3beed1ab4c299257e117aacadcf5.SD-480p-1.5Mbps-93963291.mp4","width":270,"height":480,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/564e3beed1ab4c299257e117aacadcf5/564e3beed1ab4c299257e117aacadcf5.HD-1080p-7.2Mbps-93963291.mp4","width":608,"height":1080,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/564e3beed1ab4c299257e117aacadcf5/564e3beed1ab4c299257e117aacadcf5.HD-720p-4.5Mbps-93963291.mp4","width":404,"height":720,"format":"mp4"}],"53255709819197":[{"url":"https://cdn.shopify.com/videos/c/vp/09865d245e7c4fac8fcc9b90a64fc509/09865d245e7c4fac8fcc9b90a64fc509.SD-480p-1.5Mbps-93963344.mp4","width":270,"height":480,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/09865d245e7c4fac8fcc9b90a64fc509/09865d245e7c4fac8fcc9b90a64fc509.HD-1080p-7.2Mbps-93963344.mp4","width":606,"height":1080,"format":"mp4"},{"url":"https://cdn.shopify.com/videos/c/vp/09865d245e7c4fac8fcc9b90a64fc509/09865d245e7c4fac8fcc9b90a64fc509.HD-720p-4.5Mbps-93963344.mp4","width":404,"height":720,"format":"mp4"}]});
  if (customElements.get('rdb-hero-video')) return;
  customElements.define('rdb-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.video = this.querySelector('[data-hero-player]');
      this.button = this.querySelector('[data-hero-play]');
      this.sound = this.querySelector('[data-hero-sound]');
      this.nav = this.querySelector('[data-hero-navigation]');
      this.segments = [...this.nav.querySelectorAll('button')];
      this.poster = this.querySelector('picture img');
      this.mobilePoster = this.querySelector('picture source');
      this.firstPosterSrcset = this.mobilePoster.getAttribute('srcset');
      this.hold = this.querySelector('canvas');
      try { this.sources = JSON.parse(this.querySelector('[data-video-sources]').textContent); }
      catch { return; }
      this.slides = this.sources.mobileSlides;
      this.mobile = matchMedia('(max-width: 480px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.intent = null;
      this.soundWanted = false;
      this.visible = false;
      this.autoplayBlocked = false;
      this.autoplayRetries = 0;
      this.activeIndex = 0;
      this.elapsed = 0;
      this.waiting = true;
      this.request = 0;
      this.preloads = new Map();
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.intent = !(this.playing || (this.wanted && this.waiting && !this.autoplayBlocked));
        this.sync();
      }, options);
      this.sound.addEventListener('click', () => {
        if (!this.current.hasAudio || !this.mobile.matches) return;
        this.soundWanted = !this.soundWanted;
        this.video.muted = !this.soundWanted;
        this.updateControl();
        this.sync();
      }, options);
      this.nav.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (button) this.select(Number(button.dataset.heroIndex));
      }, options);
      this.nav.addEventListener('keydown', event => {
        const offset = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
        if (offset === undefined && !['Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.activeIndex + offset;
        this.select(index);
        this.segments[this.activeIndex].focus();
      }, options);
      this.video.addEventListener('playing', () => {
        clearTimeout(this.autoplayRetry);
        this.autoplayBlocked = false;
        if (!this.wanted || !this.visible || document.hidden) { this.sync(); return; }
        this.waiting = false;
        this.revealFrame();
        this.updateControl();
        this.startClock();
        this.prefetchNeighbours();
      }, options);
      this.video.addEventListener('waiting', () => { this.waiting = true; this.stopClock(); this.updateControl(); }, options);
      this.video.addEventListener('pause', () => { this.stopClock(); this.updateControl(); }, options);
      this.video.addEventListener('ended', () => {
        this.stopClock();
        this.waiting = false;
        this.updateProgress();
        this.updateControl();
        this.startClock();
      }, options);
      for (const event of ['durationchange', 'timeupdate', 'emptied']) {
        this.video.addEventListener(event, () => this.updateProgress(), options);
      }
      this.video.addEventListener('volumechange', () => this.updateControl(), options);
      this.video.addEventListener('error', () => {
        if (!this.video.error) return;
        this.cancelFrame();
        this.stopClock();
        delete this.dataset.ready;
        this.waiting = false;
        if (this.wanted && this.visible && !document.hidden && this.mediaRetries < 1) {
          this.mediaRetries++;
          clearTimeout(this.mediaRetry);
          const request = this.request;
          this.mediaRetry = setTimeout(() => { if (request === this.request) this.sync(); }, 150);
        } else {
          delete this.dataset.held;
        }
        this.updateControl();
      }, options);
      this.mobile.addEventListener('change', () => {
        this.request++;
        this.cancelFrame();
        this.stopClock();
        this.clearPrefetch();
        this.video.pause();
        this.elapsed = 0;
        delete this.dataset.ready;
        delete this.dataset.held;
        this.configure();
        this.sync();
      }, options);
      const preferenceChanged = () => { this.clearPrefetch(); this.sync(); };
      this.reduced.addEventListener('change', preferenceChanged, options);
      this.connection?.addEventListener('change', preferenceChanged, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pageshow', () => this.sync(), options);
      this.video.addEventListener('canplay', () => this.sync(), options);
      this.video.addEventListener('loadeddata', () => this.revealFrame(), options);
      const retryAfterInteraction = event => {
        if (!event.isTrusted || event.target.closest?.('[data-hero-play], [data-hero-sound], [data-hero-index]')) return;
        if (this.autoplayBlocked && this.wanted) this.sync();
      };
      for (const event of ['touchend', 'pointerup', 'keydown']) {
        document.addEventListener(event, retryAfterInteraction, { ...options, passive: true });
      }
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      }, { threshold: 0 });
      this.observer.observe(this);
      this.hero = this.closest('.hero');
      this.hero.addEventListener('pointerdown', event => {
        if (!this.sequence || event.target.closest('button, a') || !event.isPrimary || event.button > 0) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stopClock();
      }, options);
      this.hero.addEventListener('pointerup', event => {
        if (this.gesture?.id !== event.pointerId) return;
        const dx = event.clientX - this.gesture.x, dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.select(this.activeIndex + (dx < 0 ? 1 : -1));
        else this.startClock();
      }, options);
      this.hero.addEventListener('pointercancel', () => { this.gesture = null; this.startClock(); }, options);
      this.opening = this.closest('rdb-opening');
      this.occasions = this.opening?.querySelector('.occasion-dock');
      this.occasionObserver?.disconnect();
      if (this.occasions) {
        this.occasionObserver = new ResizeObserver(() => this.measureOccasionPreview());
        this.occasionObserver.observe(this.occasions);
        this.occasionObserver.observe(this.occasions.querySelector('.occasion-rail'));
        this.measureOccasionPreview();
      }
      this.configure();
      this.sync();
    }

    get sequence() { return this.mobile.matches && this.slides.length > 1; }
    get current() { return this.mobile.matches ? this.slides[this.activeIndex] : this.sources.desktop; }
    get constrained() { return this.reduced.matches || this.connection?.saveData || ['slow-2g', '2g'].includes(this.connection?.effectiveType); }
    get wanted() { return this.intent === true || (this.intent !== false && !this.constrained); }
    get playing() {
      return this.wanted && this.visible && !document.hidden && !this.video.error &&
        ((!this.video.paused && !this.waiting) || (this.sequence && this.video.ended));
    }

    configure() {
      clearTimeout(this.autoplayRetry);
      clearTimeout(this.mediaRetry);
      this.autoplayRetries = 0;
      this.mediaRetries = 0;
      const current = this.current;
      this.dataset.sequence = String(this.sequence);
      this.dataset.activeIndex = String(this.activeIndex);
      this.dataset.mediaId = String(current.id);
      this.nav.hidden = !this.sequence;
      this.sound.hidden = !this.sequence;
      this.video.loop = !this.sequence;
      this.video.playsInline = true;
      this.video.defaultMuted = true;
      this.video.muted = !(this.mobile.matches && current.hasAudio && this.soundWanted);
      if (this.mobile.matches) {
        const width = current.zoom || 100;
        for (const node of [this.video, this.poster]) {
          node.style.width = width + '%';
          node.style.left = (100 - width) / 2 + '%';
          node.style.objectPosition = current.x + '% ' + current.y + '%';
        }
        this.mobilePoster.srcset = this.activeIndex === 0 ? this.firstPosterSrcset : current.poster;
      } else {
        for (const node of [this.video, this.poster]) {
          node.style.removeProperty('width');
          node.style.removeProperty('left');
          node.style.removeProperty('object-position');
        }
      }
      this.updateControl();
      this.updateProgress();
    }

    chooseSource(configured = this.current) {
      const quieter = this.sources.audioAdjustedSources?.[String(configured.id)];
      const candidates = (quieter || verifiedRenditions[configured.id] || configured.sources)
        .filter(source => source.format === 'mp4').slice().sort((a, b) => a.width - b.width);
      const frame = this.getBoundingClientRect();
      const ratio = configured.width / configured.height;
      const coveredWidth = Math.max(frame.width * (configured.zoom || 100) / 100, frame.height * ratio);
      const width = Math.min(coveredWidth * 1.1, ratio < 1 ? 674 : 1920);
      return candidates.find(source => source.width >= width) || candidates.at(-1);
    }

    measureOccasionPreview() {
      if (!matchMedia('(max-width: 820px)').matches) return;
      const tops = [...new Set([...this.occasions.querySelectorAll('.occasion-card__media')]
        .map(media => Math.round(media.getBoundingClientRect().top)))].sort((a, b) => a - b);
      if (tops.length < 2) return;
      this.opening.style.setProperty('--opening-occasion-preview-height', Math.ceil(tops[1] - this.occasions.getBoundingClientRect().top + 20) + 'px');
    }

    captureFrame() {
      if (this.video.readyState < 2 || !this.video.videoWidth || this.dataset.ready !== 'true') return;
      const frame = this.getBoundingClientRect(), media = this.video.getBoundingClientRect();
      const scale = Math.max(media.width / this.video.videoWidth, media.height / this.video.videoHeight);
      const width = this.video.videoWidth * scale, height = this.video.videoHeight * scale;
      const [x, y] = getComputedStyle(this.video).objectPosition.split(' ').map(parseFloat);
      try {
        const density = Math.min(window.devicePixelRatio || 1, 2);
        this.hold.width = Math.round(frame.width * density);
        this.hold.height = Math.round(frame.height * density);
        const context = this.hold.getContext('2d');
        context.scale(density, density);
        context.drawImage(this.video,
          media.left - frame.left + (media.width - width) * x / 100,
          media.top - frame.top + (media.height - height) * y / 100, width, height);
        this.dataset.held = 'true';
      } catch {
        delete this.dataset.held;
      }
    }

    cancelFrame() {
      if (this.frameCallback != null) this.video.cancelVideoFrameCallback?.(this.frameCallback);
      cancelAnimationFrame(this.framePaint);
      this.frameCallback = null;
      this.framePaint = null;
    }

    revealFrame() {
      if (this.dataset.ready === 'true' || this.frameCallback != null || this.framePaint != null ||
          this.video.readyState < 2 || this.video.paused || !this.wanted) return;
      const request = this.request, source = this.video.getAttribute('src');
      const reveal = () => {
        if (request !== this.request) return;
        this.frameCallback = null;
        this.framePaint = null;
        if (request !== this.request || !this.isConnected || !this.wanted || !this.visible || document.hidden ||
            this.video.paused || this.video.readyState < 2 || !this.video.videoWidth ||
            this.video.currentSrc !== new URL(source, document.baseURI).href) return;
        this.dataset.ready = 'true';
        delete this.dataset.held;
      };
      if (this.video.requestVideoFrameCallback) {
        this.frameCallback = this.video.requestVideoFrameCallback(reveal);
      } else {
        this.framePaint = requestAnimationFrame(() => {
          this.framePaint = requestAnimationFrame(reveal);
        });
      }
    }

    select(index) {
      if (!this.sequence) return;
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.activeIndex) return;
      this.captureFrame();
      this.request++;
      this.cancelFrame();
      this.stopClock();
      this.video.pause();
      this.activeIndex = next;
      this.elapsed = 0;
      this.waiting = true;
      delete this.dataset.ready;
      this.configure();
      if (!this.wanted) delete this.dataset.held;
      this.sync();
    }

    sync() {
      const shouldPlay = this.isConnected && this.wanted && this.visible && !document.hidden;
      this.video.autoplay = shouldPlay;
      if (!shouldPlay) {
        this.cancelFrame();
        clearTimeout(this.autoplayRetry);
        clearTimeout(this.mediaRetry);
        this.stopClock();
        this.video.pause();
        this.clearPrefetch();
        this.updateControl();
        return;
      }
      const source = this.chooseSource();
      if (!source) { this.button.hidden = true; return; }
      if (this.video.getAttribute('src') !== source.url || this.video.error) {
        this.cancelFrame();
        this.waiting = true;
        delete this.dataset.ready;
        this.video.src = source.url;
        this.video.load();
      }
      if (!this.video.paused || (this.sequence && this.video.ended)) { this.revealFrame(); this.startClock(); return; }
      const request = this.request;
      this.video.play().catch(error => {
        if (request !== this.request || error.name === 'AbortError' || !this.isConnected || !this.wanted) return;
        if (!this.video.muted && error.name === 'NotAllowedError') {
          this.soundWanted = false;
          this.video.muted = true;
          this.sync();
          return;
        }
        this.autoplayBlocked = error.name === 'NotAllowedError';
        if (this.autoplayBlocked && this.autoplayRetries < 2) {
          clearTimeout(this.autoplayRetry);
          this.autoplayRetry = setTimeout(() => this.sync(), 300 * ++this.autoplayRetries);
        }
        this.updateControl();
      });
    }

    startClock() {
      if (this.clock || !this.sequence || !this.playing || this.gesture) return;
      if (this.video.ended) { this.select(this.activeIndex + 1); return; }
      const tick = () => {
        this.clock = null;
        if (!this.sequence || !this.playing || this.gesture) return;
        this.updateProgress();
        if (!this.video.ended) this.clock = requestAnimationFrame(tick);
      };
      this.clock = requestAnimationFrame(tick);
    }

    stopClock() { cancelAnimationFrame(this.clock); this.clock = null; }

    updateProgress() {
      this.elapsed = this.video.currentTime * 1000;
      const duration = this.video.duration;
      const progress = Number.isFinite(duration) && duration > 0
        ? Math.min(this.video.currentTime / duration, 1) : 0;
      this.segments.forEach((button, index) => {
        button.setAttribute('aria-current', String(index === this.activeIndex));
        button.tabIndex = index === this.activeIndex ? 0 : -1;
        button.style.setProperty('--hero-progress', index < this.activeIndex ? 1 : index === this.activeIndex ? progress : 0);
      });
    }

    updateControl() {
      const playing = this.playing || (this.wanted && this.visible && !document.hidden && this.waiting && !this.autoplayBlocked && !this.video.error);
      this.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      this.sound.disabled = !this.current.hasAudio;
      this.sound.setAttribute('aria-label', !this.current.hasAudio ? this.dataset.noSoundLabel : this.video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
      this.sound.setAttribute('aria-pressed', String(!this.video.muted && !!this.current.hasAudio));
      this.dataset.muted = String(this.video.muted || !this.current.hasAudio);
    }

    prefetchNeighbours() {
      if (!this.sequence || this.constrained || !this.playing) return;
      const urls = [1, -1].map(offset => this.chooseSource(this.slides[(this.activeIndex + offset + this.slides.length) % this.slides.length])?.url).filter(Boolean);
      const activeSource = this.video.getAttribute('src');
      for (const [url, video] of this.preloads) {
        if (urls.includes(url) || url === activeSource) continue;
        video.removeAttribute('src');
        video.load();
        this.preloads.delete(url);
      }
      for (const url of urls) {
        if (this.preloads.has(url)) continue;
        const video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.src = url;
        video.load();
        this.preloads.set(url, video);
      }
    }

    clearPrefetch() {
      for (const video of this.preloads?.values() || []) {
        video.removeAttribute('src');
        video.load();
      }
      this.preloads?.clear();
    }

    disconnectedCallback() {
      this.request++;
      this.cancelFrame();
      clearTimeout(this.autoplayRetry);
      clearTimeout(this.mediaRetry);
      if (this.video) this.video.autoplay = false;
      this.stopClock();
      this.events?.abort();
      this.observer?.disconnect();
      this.occasionObserver?.disconnect();
      this.clearPrefetch();
      this.video?.pause();
      this.video?.removeAttribute('src');
      this.video?.load();
    }
  });
})();
